import {
    connect,
    injectReducer,
    injectSaga,
} from '@vfde-sails/core';
import saga from './saga';
import reducer from './reducer';
import * as mapDispatch from './action';
import { mapStateToProps } from './selector';
import { mountLoadingSpinner } from '../../components/loadingSpinner';
import { HtmlId } from '../../enums/elementId';
import isCmsConfigValid from '../../util/cmsValidator';
import { ErrorType } from './enum';
import { Namespace } from '../../enum';
import { getUpdateFlags } from './update';
import {
    loadInitialAppState,
    saveStateToSession,
} from '../../util/session.util';
import {
    toggleElementsVisibilityById,
    toggleElementVisibilityById,
} from '@vfde-brix/ws10/core';
import { debugInfo } from '@vfde-sails/utils';
import { mountStepperButtons } from '../../components/buttonLink';
import { mountPathfinderModules } from '../../components/pathfinder';
import { getCMSLevelIds } from '../../util/cms';
import { mountAccordions } from '../../components/accordion';
import { mountRelatedLinks } from '../../components/relatedLinks';
import { mountIconTextBanners } from '../../components/iconTextBanner';

type State = ReturnType<typeof mapStateToProps>;
/** App action types */
export type Actions = typeof mapDispatch;

const mountApp = (actions: Actions) => {
    if (!isCmsConfigValid()) {
        actions.setError({
            type: ErrorType.CmsConfig,
            error: Error('Invalid CMS config!'),
        });

        debugInfo('CMS Config is invalid!');

        return { loadingSpinner: null };
    }

    const loadingSpinner = mountLoadingSpinner(HtmlId.Loading);
    mountStepperButtons(actions.stepToPrevLevel);
    mountPathfinderModules(actions);
    mountAccordions();
    mountRelatedLinks();
    mountIconTextBanners();

    return { loadingSpinner };
};

function appContainer (state: State, actions: Actions) {
    injectSaga(Namespace.App, saga);
    injectReducer(Namespace.App, reducer);

    const { loadingSpinner } = mountApp(actions);

    actions.initStore(loadInitialAppState());

    return {
        getDerivedStateFromProps (newState: State, oldState: State) {
            const update = getUpdateFlags(newState, oldState);

            update.loading && loadingSpinner?.toggle(newState.isLoading);

            if (update.initError) {
                toggleElementVisibilityById(HtmlId.Error, true);
                toggleElementVisibilityById(HtmlId.App, false);
            }

            if (update.level) {
                toggleElementsVisibilityById(getCMSLevelIds(), false);
                toggleElementVisibilityById(newState.currentLevelId, true);
            }

            saveStateToSession(newState);
        },
    };
}

export default connect(mapStateToProps, mapDispatch)(appContainer);
